class UsersGroupsApiResponseModel {
  // #region Props
  idGrupo;
  nombre;
  tipo;
  numeroUsuarios;
  usuarios;
  // #endregion

  constructor(object) {
    // Assign props to this object instance
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default UsersGroupsApiResponseModel;
